import * as React from 'react'
import { Link } from 'react-router-dom'
import { Building2, CalendarCheck, CreditCard, FlaskConical, History, LayoutDashboard, Link2, Mail, ScanEye, Search, SwatchBook, Target, TrendingUp, UserCog, Users } from 'lucide-react'

import { NavMain, type NavItem } from '@/components/nav-main'
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from '@/components/ui/sidebar'
import roasformIcon from '@/assets/roasform-icon-small.png'
import roasformLogo from '@/assets/roasform-logo.png'

const mainNavItems: NavItem[] = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    title: 'Revenue',
    url: '/revenue',
    icon: CreditCard,
  },
  {
    title: 'Onboarding',
    url: '/onboarding',
    icon: CalendarCheck,
    alwaysOpen: true,
    items: [
      { title: 'Appointments', url: '/onboarding/appointments' },
    ],
  },
  {
    title: 'Affiliates',
    url: '/affiliates',
    icon: Link2,
  },
  {
    title: 'Agencies',
    url: '/agencies',
    icon: Building2,
  },
  {
    title: 'Campaigns',
    url: '/campaigns',
    icon: TrendingUp,
  },
  {
    title: 'Users',
    url: '/users',
    icon: Users,
  },
  {
    title: 'Team',
    url: '/team',
    icon: UserCog,
  },
  {
    title: 'X-Ray',
    url: '/xray',
    icon: ScanEye,
    alwaysOpen: true,
    items: [
      { title: 'Overview', url: '/xray/overview' },
      { title: 'Settings', url: '/xray/settings' },
      { title: 'Compliance', url: '/xray/compliance' },
    ],
  },
  {
    title: 'Meta Pixel Tracking',
    url: '/tracking',
    icon: Target,
  },
  {
    title: 'Lookup',
    url: '/lookup',
    icon: Search,
  },
  {
    title: 'Templates',
    url: '/templates',
    icon: SwatchBook,
  },
  {
    title: 'Emails',
    url: '/emails',
    icon: Mail,
  },
  {
    title: 'Changelog',
    url: '/changelog',
    icon: History,
  },
  {
    title: 'Labs',
    url: '/labs',
    icon: FlaskConical,
    alwaysOpen: true,
    items: [
      { title: 'AI Preview', url: '/labs/ai-preview' },
    ],
  },
]

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  return (
    <Sidebar collapsible="icon" { ...props }>
      <SidebarHeader className="p-0">
        <div className={`flex items-center justify-center h-16 border-b ${isCollapsed ? 'px-0' : 'px-4'}`}>
          <Link to="/">
            {isCollapsed ? (
              <img src={roasformIcon} alt="ROASForm" className="h-7 w-7" />
            ) : (
              <img src={roasformLogo} alt="ROASForm" className="h-6" />
            )}
          </Link>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={ mainNavItems } />
      </SidebarContent>

      <SidebarRail />
    </Sidebar >
  )
}
